<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Subscription") }}</h3>
      </md-toolbar>
      <br />
    </div>
    <div class="md-layout-item md-medium-size-80 md-xsmall-size-100">
      <md-steppers
        md-primary
        md-alternative
        :md-active-step.sync="active"
        md-linear
      >
        <md-step
          id="first"
          md-label="Plan"
          :md-done.sync="first"
          :md-editable="false"
        >
          <div class="md-layout">
            <div class="md-layout-item md-size-10 md-small-hide"></div>
            <div class="md-layout-item md-size-40 md-small-size-100">
              <md-card>
                <md-card-header>
                  <div class="md-title">{{ $t("Pro plan") }}</div>
                  <div class="md-subhead">
                    {{
                      "$5 /" +
                        $t("month") +
                        " " +
                        $t("or") +
                        " $36 /" +
                        $t("year")
                    }}<br />{{ $t("single pilot plan") }}
                  </div>
                </md-card-header>
                <md-card-expand>
                  <md-card-actions md-alignment="space-between">
                    <md-card-expand-trigger>
                      <md-button class="md-raised md-primary md-simple">{{
                        $t("Learn More")
                      }}</md-button>
                    </md-card-expand-trigger>
                  </md-card-actions>

                  <md-card-expand-content>
                    <md-card-content>
                      <ul>
                        <li>{{ $t("Automated Site Surveys") }}</li>
                        <li>
                          {{
                            $t("Schedule Flights in Advance on WEB & Mobile")
                          }}
                        </li>
                        <li>
                          {{ $t("Complete Access to CFS, VTA, VNC, CWAS") }}
                          <br />({{
                            $t("aeronautical charts costing over $1000/yr!")
                          }})
                        </li>
                        <li>
                          {{
                            $t("Customizable Checklist + Checklist Timestamps")
                          }}
                          <br />{{ $t("Integrated Flight Log") }}
                        </li>
                        <li>
                          {{ $t("Single Pilot User") }} <br />{{
                            $t("Multiple Device Management")
                          }}
                        </li>
                      </ul>
                    </md-card-content>
                  </md-card-expand-content>
                </md-card-expand>
              </md-card>
            </div>
            <div class="md-layout-item md-size-40 md-small-size-100">
              <md-card>
                <!-- <div class="ribbon ribbon-top-right" style="z-index: 3;">
                  <span>{{ $t("GREAT VALUE") }}</span>
                </div> -->
                <md-card-header>
                  <div class="md-title">{{ $t("Enterprise plan") }}</div>
                  <div class="md-subhead">
                    {{ $t("Contact us") }}<br />{{ $t("multi-pilot plan") }}
                  </div>
                </md-card-header>
                <md-card-expand>
                  <md-card-actions md-alignment="space-between">
                    <md-card-expand-trigger>
                      <md-button class="md-raised md-primary md-simple">{{
                        $t("Learn More")
                      }}</md-button>
                    </md-card-expand-trigger>
                  </md-card-actions>

                  <md-card-expand-content>
                    <md-card-content>
                      <ul>
                        <li>{{ $t("Automated Site Surveys") }}</li>
                        <li>
                          {{ $t("Complete Access to CFS, VTA, VNC, CWAS") }}
                          <br />({{
                            $t("aeronautical charts costing over $1000/yr!")
                          }})
                        </li>
                        <li>
                          {{
                            $t("Customizable Checklist + Checklist Timestamps")
                          }}
                          <br />{{ $t("Integrated Flight Log") }}
                        </li>
                        <li>
                          {{ $t("Multiple Pilot Management + Training Log") }}
                          <br />{{
                            $t("Multiple Device Management + Maintenance Log")
                          }}
                          <br />{{ $t("Client Management") }}
                        </li>
                        <li>
                          {{ $t("Admin Dashboard to Monitor Team Activity")
                          }}<br />
                          {{ $t("Create Site Surveys for Team") }}<br />
                          {{
                            $t(
                              "Smart Alerts for Incident Notification and Early Warnings"
                            )
                          }}
                        </li>
                      </ul>
                    </md-card-content>
                  </md-card-expand-content>
                </md-card-expand>
              </md-card>
            </div>
            <div class="md-layout-item md-size-10 md-small-hide"></div>

            <div class="md-layout-item md-size-10 md-small-hide"></div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-card>
                <md-card-header>
                  <div class="md-title">{{ $t("Plan Calculator") }}</div>
                  <div class="md-subhead">
                    {{
                      $t(
                        "Please Select Plan, Term, and # of Pilot (for enterprise)"
                      )
                    }}
                    <br />
                    <br /><i style="font-size: 12px;">
                      {{
                        $t(
                          "The Subscription renews automatically at the end of the Subscription Term. Payment is taken automatically at the beginning of the new Subscription Term."
                        )
                      }}
                    </i>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-5 md-small-hide"></div>
                    <div class="md-layout-item md-size-80 md-small-size-100">
                      <h2 class="card-title">
                        <small>$</small>
                        {{ selectedPlanSubtotal }}
                        <small>{{
                          selectedFrequency === "y"
                            ? "/" + $t("yr")
                            : "/" + $t("mo")
                        }}</small>
                      </h2>
                    </div>
                    <div class="md-layout-item md-size-80 md-small-size-100">
                      <div class="md-layout" style="align-items: center;">
                        <div
                          class="md-layout-item md-size-40 md-small-size-100"
                        >
                          <div class="md-title" md-align="center">
                            {{ $t("Plan") + ":" }}
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-size-60 md-small-size-100"
                        >
                          <md-radio
                            v-model="selectedPlanType"
                            value="Enterprise"
                            @change="updatePlan"
                            >{{ $t("Enterprise") }}</md-radio
                          >
                          <md-radio
                            v-model="selectedPlanType"
                            value="Pro"
                            @change="updatePlan"
                            >{{ $t("Pro") }}</md-radio
                          >
                        </div>
                        <div
                          class="md-layout-item md-size-40 md-small-size-100"
                        >
                          <div class="md-title" md-align="center">
                            {{ $t("Term") + ":" }}
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-size-60 md-small-size-100"
                        >
                          <md-radio
                            v-model="selectedFrequency"
                            value="y"
                            @change="updateFrequency"
                            >{{ $t("Yearly") }}</md-radio
                          >
                          <md-radio
                            v-model="selectedFrequency"
                            value="m"
                            @change="updateFrequency"
                            >{{ $t("Monthly") }}</md-radio
                          >
                        </div>
                        <div
                          class="md-layout-item md-size-40 md-small-size-100"
                        >
                          <div class="md-title" md-align="center">
                            {{ $t("Pilots") + ":" }}
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-size-60 md-small-size-100"
                        >
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-round"
                            @click="decreaseQuantity"
                          >
                            <i class="material-icons" style="top: 0px;"
                              >remove</i
                            >
                          </md-button>
                          <span class="quantity">{{ selectedQuantity }}</span>
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-round"
                            @click="increaseQuantity"
                          >
                            <i class="material-icons" style="top: 0px;">add</i>
                          </md-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </md-card-header>
                <!-- <md-card-expand>
                  <md-card-actions md-alignment="space-between">
                    <div>
                      <md-button
                        href="javascript:void(0)"
                        class="md-rose"
                        @click="reset"
                        >{{ $t("Reset") }}
                      </md-button>
                    </div>
                  </md-card-actions>
                </md-card-expand> -->
              </md-card>
            </div>
            <div class="md-layout-item md-size-10 md-small-hide"></div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <div @click="setDone('first', 'second')">
                    <md-card
                      class="md-primary"
                      md-with-hover
                      style="min-height: 100px;"
                    >
                      <md-ripple>
                        <md-card-content style="color: white;">
                          <div class="md-title">{{ $t("Next") + " >" }}</div>
                          <div class="md-subhead">
                            {{ $t("Billing Information") }}
                          </div>
                        </md-card-content>
                      </md-ripple>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </md-step>

        <md-step
          id="second"
          md-label="Billing"
          :md-done.sync="second"
          :md-editable="false"
        >
          <div class="md-layout">
            <div class="md-layout-item md-size-10 md-small-hide"></div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <Profile_sub header-color="primary"></Profile_sub>
                </div>
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <Payment header-color="primary"></Payment>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-10 md-small-hide"></div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <div @click="setDone('second', 'third')">
                    <md-card
                      class="md-primary"
                      md-with-hover
                      style="min-height: 100px;"
                    >
                      <md-ripple>
                        <md-card-content style="color: white;">
                          <div class="md-title">{{ $t("Next") + " >" }}</div>
                          <div class="md-subhead">
                            {{ $t("Checkout") }}
                          </div>
                        </md-card-content>
                      </md-ripple>
                    </md-card>
                  </div>
                </div>
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <div @click="setDone('second', 'first')">
                    <md-card
                      class="md-primary"
                      md-with-hover
                      style="min-height: 100px;"
                    >
                      <md-ripple>
                        <md-card-content style="color: white;">
                          <div class="md-title">
                            {{ $t("Previous") + " &lt;" }}
                          </div>
                          <div class="md-subhead">
                            {{ $t("Review Plan") }}
                          </div>
                        </md-card-content>
                      </md-ripple>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-10 md-small-hide"></div>
          </div>
        </md-step>

        <md-step
          id="third"
          md-label="Checkout"
          :md-done.sync="third"
          :md-editable="false"
        >
          <div class="md-layout">
            <div class="md-layout-item md-size-10 md-small-hide"></div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-card>
                <md-card-header>
                  <div class="md-title">{{ $t("Plan Summary") }}</div>
                  <div class="md-subhead">
                    {{ $t("Please review the details") }}

                    <br />
                    <br /><i style="font-size: 12px;">
                      {{
                        $t(
                          "The Subscription renews automatically at the end of the Subscription Term. Payment is taken automatically at the beginning of the new Subscription Term."
                        )
                      }}
                    </i>
                  </div>
                </md-card-header>

                <md-card-content>
                  <md-list class="md-double-line">
                    <md-subheader>{{ $t("Plan") }}</md-subheader>
                    <md-list-item>
                      <md-icon class="md-primary">description</md-icon>
                      <div class="md-list-item-text">
                        <span>{{ $t(selectedPlanType) }}</span>
                        <span>{{ $t("Selected plan") }}</span>
                      </div>
                    </md-list-item>
                    <md-divider></md-divider>
                    <md-subheader>{{ $t("Term") }}</md-subheader>
                    <md-list-item>
                      <md-icon class="md-primary">update</md-icon>
                      <div class="md-list-item-text">
                        <span>{{ $t(selectedFreqLong) }}</span>
                        <span>{{ $t("Selected term") }}</span>
                      </div>
                    </md-list-item>
                    <md-divider></md-divider>
                    <md-subheader>{{ $t("Pilots") }}</md-subheader>
                    <md-list-item>
                      <md-icon class="md-primary">group_add</md-icon>
                      <div class="md-list-item-text">
                        <span>{{ selectedQuantity }}</span>
                        <span>{{ $t("Number of pilots") }}</span>
                      </div>
                    </md-list-item>
                    <md-divider></md-divider>
                    <div v-show="!this.code_valid">
                      <md-subheader>{{ $t("Plan total") }}</md-subheader>
                      <md-list-item>
                        <md-icon class="md-primary">monetization_on</md-icon>
                        <div class="md-list-item-text">
                          <span>${{ selectedPlanCost }}</span>
                          <span>{{
                            $t(
                              "Total of selected plan and term for number of pilots"
                            )
                          }}</span>
                        </div>
                      </md-list-item>
                      <md-divider></md-divider>
                    </div>
                    <div v-show="!this.code_valid" v-if="!this.coupon_used">
                      <md-subheader>{{ $t("Coupon") }}</md-subheader>
                      <md-list-item>
                        <md-icon class="md-primary">local_offer</md-icon>
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-small-size-100 md-size-30"
                            style="padding-left: 0px;"
                          >
                            <div class="md-list-item-text">
                              <span>${{ discountAmount }}</span>
                              <span>{{ $t("Discount") }}</span>
                            </div>
                          </div>
                          <div
                            class="md-layout-item md-small-size-100 md-size-70"
                          >
                            <div class="md-layout">
                              <div
                                class="md-layout-item md-small-size-100 md-size-60"
                              >
                                <div class="md-list-item-text">
                                  <span>
                                    <md-field>
                                      <md-input v-model="code"></md-input>
                                    </md-field>
                                  </span>
                                  <span>{{ $t("Enter code") }}</span>
                                </div>
                              </div>
                              <div
                                class="md-layout-item md-small-size-100 md-size-30"
                              >
                                <md-button
                                  href="javascript:void(0)"
                                  class=""
                                  @click="applyCoupon"
                                  style="margin-left:10px"
                                  >{{ $t("Apply") }}
                                </md-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </md-list-item>
                    </div>
                    <md-divider></md-divider>
                    <md-subheader>{{ $t("Subtotal") }}</md-subheader>
                    <md-list-item>
                      <md-icon class="md-primary">monetization_on</md-icon>
                      <div class="md-list-item-text">
                        <span>${{ selectedPlanSubtotal }}</span>
                        <span>{{ $t("Total before tax") }}</span>
                      </div>
                    </md-list-item>
                    <md-divider></md-divider>
                    <md-subheader>{{ $t("Tax") }}</md-subheader>
                    <md-list-item>
                      <md-icon class="md-primary">add_circle_outline</md-icon>
                      <div class="md-list-item-text">
                        <span>${{ applicableTax }} {{ taxType }} </span>
                        <span>{{ $t("Applicable taxes") }}</span>
                      </div>
                    </md-list-item>
                    <md-divider></md-divider>
                    <md-subheader>{{ $t("Total") }}</md-subheader>
                    <md-list-item>
                      <md-icon class="md-primary">monetization_on</md-icon>
                      <div class="md-list-item-text">
                        <span>${{ selectedPlanCostFinal }}</span>
                        <span>{{ $t("Total") }}</span>
                      </div>
                    </md-list-item>
                    <md-divider></md-divider>
                  </md-list>
                </md-card-content>
              </md-card>
            </div>
            <div class="md-layout-item md-size-10 md-small-hide"></div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <div @click="setDone('third', 'end')">
                    <md-card
                      class="md-primary"
                      md-with-hover
                      style="min-height: 100px;"
                    >
                      <md-ripple>
                        <md-card-content>
                          <div class="md-title">{{ $t("Subscribe") }}</div>
                          <div class="md-subhead">
                            {{ $t("Complete Subscription") }}
                          </div>
                        </md-card-content>
                      </md-ripple>
                    </md-card>
                  </div>
                </div>
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <div @click="setDone('third', 'second')">
                    <md-card
                      class="md-primary"
                      md-with-hover
                      style="min-height: 100px;"
                    >
                      <md-ripple>
                        <md-card-content>
                          <div class="md-title">
                            {{ $t("Previous") + " &lt;" }}
                          </div>
                          <div class="md-subhead">
                            {{ $t("Review Billing") }}
                          </div>
                        </md-card-content>
                      </md-ripple>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </md-step>
      </md-steppers>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import swal from "sweetalert2";
import { EventBus } from "@/helpers";
import "@/assets/css/ribbon.css";
import { router } from "../../main";
import { USER_TYPE } from "@/const.js";
import Payment from "./Pages/UserProfile/Payment.vue";
import Profile_sub from "./Pages/UserProfile/Profile_sub.vue";
import { taxRate } from "@/helpers/utils";

export default {
  name: "subscription",
  components: {
    Profile_sub,
    Payment
  },
  data() {
    return {
      USER_TYPE: USER_TYPE,
      selectedQuantity: 0,
      selectedFrequency: undefined,
      selectedFreqLong: undefined,
      selectedPlanType: undefined,
      selectedPlanCost: 0,
      selectedPlanSubtotal: 0,
      selectedPlanCostFinal: 0,
      taxRates: 0,
      applicableTax: 0,
      taxType: undefined,
      enterpriseCost: 0,
      proCost: 0,
      percentCoupon: false,
      discountAmount: 0,
      code: "",
      code_id: "",
      code_valid: false,
      percentOff: 0.0,
      active: "first",
      first: false,
      second: false,
      third: false
    };
  },
  computed: {
    ...mapFields("auth", [
      "plan_type",
      "cancelled",
      "coupon_used",
      "plan_freq",
      "quantity",
      "card_last4",
      "province",
      "current_period_end_date"
    ]),
    ...mapFields("setting", ["pilotQuantity"])
  },
  beforeMount() {
    if (
      this.$store.state.auth.usertype === USER_TYPE.PILOT ||
      this.$store.state.auth.usertype === USER_TYPE.SUPER
    ) {
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("Only administrator can access subscription page!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    }
  },
  mounted() {
    if (this.quantity === 0) {
      this.selectedQuantity = 1;
    } else {
      this.selectedQuantity = this.quantity;
    }
    if (this.plan_type === USER_TYPE.FREE) {
      this.selectedQuantity = 1;
      this.selectedPlanType = "Pro";
      this.selectedFrequency = "y";
      this.selectedFreqLong = "Yearly";
    } else if (this.plan_type === USER_TYPE.FREE && this.pilotQuantity > 0) {
      this.selectedQuantity = this.pilotQuantity;
      this.selectedPlanType = "Pro";
      this.selectedFrequency = "y";
      this.selectedFreqLong = "Yearly";
    } else if (this.plan_type === undefined && this.pilotQuantity > 0) {
      this.selectedQuantity = this.pilotQuantity;
      this.selectedPlanType = "Pro";
      this.selectedFrequency = "y";
      this.selectedFreqLong = "Yearly";
    } else if (this.plan_type === undefined) {
      this.selectedQuantity = 1;
      this.selectedPlanType = "Pro";
      this.selectedFrequency = "y";
      this.selectedFreqLong = "Yearly";
    } else {
      this.selectedQuantity = this.quantity;
      this.selectedPlanType = this.plan_type;
      this.selectedFrequency = this.plan_freq;
    }

    const { taxRates, taxType } = taxRate(this.province);
    this.taxRates = taxRates;
    this.taxType = taxType;
    this.updatePrice();

    EventBus.$on("updatedSubscription", () => {
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t("You successfully updated subscription!"),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
      router.push("/dashboard");
    });

    EventBus.$on("canceledSubscription", () => {
      swal.fire({
        title: this.$t("Confirmation"),
        text: this.$t("You successfully canceled subscription!"),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });

    EventBus.$on("failedUpdateSubscription", () => {
      swal.fire({
        title: this.$t("Confirmation"),
        text: this.$t("Failed to update subscription."),
        type: "error",
        confirmButtonClass: "md-button md-error",
        buttonsStyling: false
      });
    });

    EventBus.$on("retrieveCoupon", data => {
      if (data.error) {
        swal.fire({
          title: this.$t("Confirmation"),
          text: this.$t("Failed to retrieve coupon."),
          type: "error",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
        if (this.selectedPlanType === "Enterprise") {
          this.selectedPlanType = "Pro";
          this.updatePrice();
        }
        this.code_valid = false;
      } else if (!data.active || !data.coupon.valid) {
        swal.fire({
          title: this.$t("Confirmation"),
          text: this.$t("Coupon is not valid."),
          type: "error",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
        if (this.selectedPlanType === "Enterprise") {
          this.selectedPlanType = "Pro";
          this.updatePrice();
        }
        this.code_valid = false;
      } else {
        if (parseFloat(data.coupon.amount_off) > 0) {
          this.percentOff = (parseFloat(data.coupon.amount_off) / 100).toFixed(
            2
          );
          this.percentCoupon = false;
        } else if (parseFloat(data.coupon.percent_off) > 0) {
          this.percentOff = (parseFloat(data.coupon.percent_off) / 100).toFixed(
            2
          );
          this.percentCoupon = true;
        }
        this.code_valid = true;
        this.code_id = data.id;
        this.updatePrice();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("updatedSubscription");
    EventBus.$off("canceledSubscription");
    EventBus.$off("failedUpdateSubscription");
    EventBus.$off("retrieveCoupon");
  },
  methods: {
    setDone(id, index) {
      this[id] = true;

      if (id === "first") {
        if (
          this.selectedPlanType === undefined ||
          this.selectedFrequency === undefined
        ) {
          swal.fire({
            title: this.$t("Plan Selection Issue"),
            text: this.$t(
              "Please go back to 'Plan' step to review your selection and try again."
            ),
            type: "warning",
            confirmButtonClass: "md-button md-warning",
            buttonsStyling: false
          });
          this["first"] = true;
          this["second"] = false;
          this["third"] = false;
          this.active = "first";
          this.setDone("second", "first");
        } else if (
          this.selectedFrequency === this.plan_freq &&
          this.selectedPlanType === this.plan_type &&
          this.selectedQuantity === this.quantity &&
          !this.cancelled
        ) {
          swal.fire({
            title: this.$t("Plan Selection Issue"),
            text: this.$t(
              "You have selected same plan as your current subscription. Please review and try again."
            ),
            type: "warning",
            confirmButtonClass: "md-button md-warning",
            buttonsStyling: false
          });
          this["first"] = true;
          this["second"] = false;
          this["third"] = false;
          this.active = "first";
          this.setDone("second", "first");
          this.reset();
        } else if (
          this.selectedPlanType === "Pro" &&
          this.plan_type === "Enterprise" &&
          this.quantity > 1
        ) {
          swal.fire({
            title: this.$t("Plan Downgrade Issue"),
            text: this.$t(
              "Due to limitation on Pro plan, please contact us for assistance."
            ),
            type: "warning",
            confirmButtonClass: "md-button md-warning",
            buttonsStyling: false
          });
          this["first"] = true;
          this["second"] = false;
          this["third"] = false;
          this.active = "first";
          this.setDone("second", "first");
          this.reset();
        } else {
          this["first"] = true;
          this["second"] = false;
          this["third"] = false;
          this.active = "second";
        }
      } else if (id === "second") {
        if (index === "third") {
          if (this.card_last4 === undefined) {
            swal.fire({
              title: this.$t("Missing credit card details"),
              text: this.$t("Please add a credit card first!"),
              type: "warning",
              confirmButtonClass: "md-button md-warning",
              buttonsStyling: false
            });
            this["first"] = true;
            this["second"] = false;
            this["third"] = false;
            this.active = "second";
            this.setDone("third", "second");
          } else if (
            this.$store.state.auth.firstname === undefined ||
            this.$store.state.auth.lastname === undefined ||
            this.$store.state.auth.phone === undefined ||
            this.$store.state.auth.street === undefined ||
            this.$store.state.auth.city === undefined ||
            this.$store.state.auth.province === undefined ||
            this.$store.state.auth.postalcode === undefined ||
            this.$store.state.auth.firstname === "" ||
            this.$store.state.auth.lastname === "" ||
            this.$store.state.auth.phone === "" ||
            this.$store.state.auth.street === "" ||
            this.$store.state.auth.city === "" ||
            this.$store.state.auth.province === "" ||
            this.$store.state.auth.postalcode === ""
          ) {
            swal.fire({
              title: this.$t("Missing Profile details"),
              text: this.$t(
                "Please review your profile details and fill in any missing fields."
              ),
              type: "warning",
              confirmButtonClass: "md-button md-warning",
              buttonsStyling: false
            });
            this["first"] = true;
            this["second"] = false;
            this["third"] = false;
            this.active = "second";
            this.setDone("third", "second");
          } else {
            this["first"] = true;
            this["second"] = true;
            this["third"] = false;
            this.active = "third";
          }
        } else {
          this["first"] = false;
          this["second"] = false;
          this["third"] = false;
          this.active = "first";
        }
      } else if (id === "third") {
        if (index === "end") {
          if (
            this.selectedPlanType === undefined ||
            this.selectedFrequency === undefined
          ) {
            swal.fire({
              title: this.$t("Plan Selection Issue"),
              text: this.$t(
                "Please go back to 'Plan' step to review your selections and try again."
              ),
              type: "warning",
              confirmButtonClass: "md-button md-warning",
              buttonsStyling: false
            });
            this["first"] = true;
            this["second"] = false;
            this["third"] = false;
            this.active = "first";
            this.setDone("second", "first");
          } else {
            this.submit();
          }
        } else {
          this["first"] = true;
          this["second"] = false;
          this["third"] = false;
          this.active = "second";
          this.setDone("first", "second");
        }
      }
    },
    updatePrice() {
      this.enterpriseCost = 0;
      this.proCost = 0;
      this.selectedPlanCost = 0;
      this.selectedPlanSubtotal = 0;
      if (
        this.plan_type !== "Enterprise" &&
        this.selectedPlanType === "Enterprise" &&
        !this.code_valid
      ) {
        swal
          .fire({
            title: this.$t("Please contact us for assistance."),
            text:
              "If you are interested in Enterprise plan, pelase contact us for more details",
            type: "warning",
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: false,
            cancelButtonClass: "md-button md-warning",
            cancelButtonText: "Close"
          })
          .then(result => {
            if (result.value) {
              this.code = result.value;
              this.applyCoupon();
            } else {
              this.selectedPlanType = "Pro";
              this.updatePrice();
            }
          });
      } else if (
        this.plan_type !== "Enterprise" &&
        this.selectedPlanType === "Enterprise" &&
        this.code_valid
      ) {
        if (this.selectedFrequency === "y") {
          /* if (this.selectedQuantity > 20) {
            this.enterpriseCost =
              200 * 10 + 150 * 10 + 100 * (this.selectedQuantity - 20);
          } else if (this.selectedQuantity > 10) {
            this.enterpriseCost = 200 * 10 + 150 * (this.selectedQuantity - 10);
          } else {
            this.enterpriseCost = 200 * this.selectedQuantity;
          } */
          this.enterpriseCost = 62.5 * this.selectedQuantity;
          this.selectedFreqLong = "Yearly";
        } else {
          /* if (this.selectedQuantity > 20) {
            this.enterpriseCost =
              28 * 10 + 21 * 10 + 14 * (this.selectedQuantity - 20);
          } else if (this.selectedQuantity > 10) {
            this.enterpriseCost = 28 * 10 + 21 * (this.selectedQuantity - 10);
          } else {
            this.enterpriseCost = 28 * this.selectedQuantity;
          } */
          this.enterpriseCost = 28 * this.selectedQuantity;
          this.selectedFreqLong = "Monthly";
        }

        if (this.percentCoupon) {
          this.discountAmount = (this.enterpriseCost * this.percentOff).toFixed(
            2
          );
        } else {
          this.discountAmount = this.percentOff;
        }

        this.selectedPlanCost = this.enterpriseCost;
        this.selectedPlanSubtotal = (
          this.selectedPlanCost - this.discountAmount
        ).toFixed(2);
        this.applicableTax = (
          this.selectedPlanSubtotal * this.taxRates
        ).toFixed(2);
        this.selectedPlanCostFinal = (
          this.selectedPlanSubtotal *
          (1 + this.taxRates)
        ).toFixed(2);
      } else if (this.plan_type !== "Enterprise") {
        if (this.selectedQuantity > 1) {
          swal.fire({
            title: this.$t("Warning"),
            text: this.$t("Pro subscription can only add one pilot."),
            type: "warning",
            confirmButtonClass: "md-button md-warning",
            buttonsStyling: false
          });
          this.selectedQuantity--;
          this.updatePrice();
        } else {
          if (this.selectedFrequency === "y") {
            this.proCost = 36 * this.selectedQuantity;
            this.selectedFreqLong = "Yearly";
          } else {
            this.proCost = 5 * this.selectedQuantity;
            this.selectedFreqLong = "Monthly";
          }
          if (this.percentCoupon) {
            this.discountAmount = (this.proCost * this.percentOff).toFixed(2);
          } else {
            this.discountAmount = this.percentOff.toFixed(2);
          }
          this.selectedPlanCost = this.proCost.toFixed(2);
          this.selectedPlanSubtotal = (
            this.selectedPlanCost - this.discountAmount
          ).toFixed(2);
          this.applicableTax = (
            this.selectedPlanSubtotal * this.taxRates
          ).toFixed(2);
          this.selectedPlanCostFinal = (
            this.selectedPlanSubtotal *
            (1 + this.taxRates)
          ).toFixed(2);
        }
      }
    },
    decreaseQuantity() {
      if (this.pilotQuantity === this.selectedQuantity) {
        swal.fire({
          title: this.$t("Failed to update pilot quantity!"),
          text:
            this.$t("There are") +
            " " +
            this.pilotQuantity +
            " " +
            this.$t("pilots") +
            " " +
            this.$t("in use") +
            ". " +
            this.$t("Please remove pilots."),
          type: "error",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
        return;
      }
      if (this.selectedQuantity > 1) {
        this.selectedQuantity--;
        this.updatePrice();
      }
    },
    increaseQuantity() {
      if (this.selectedQuantity < 99) {
        this.selectedQuantity++;
      }
      this.updatePrice();
    },
    updateFrequency() {
      if (this.selectedFrequency === "m" && this.plan_freq === "y") {
        swal.fire({
          title: this.$t("Plan Downgrade Issue"),
          text:
            this.$t("Your plan is good until:") +
            " " +
            this.current_period_end_date +
            ". " +
            this.$t("Please contact us for assistance."),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        this.reset();
      } else {
        this.updatePrice();
      }
    },
    updatePlan() {
      if (
        this.selectedPlanType === undefined ||
        this.selectedFrequency === undefined
      ) {
        swal.fire({
          title: this.$t("Plan Selection Issue"),
          text: this.$t(
            "Please go back to 'Plan' step to review your selections and try again."
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
      } else if (
        this.selectedFrequency === this.plan_freq &&
        this.selectedPlanType === this.plan_type &&
        this.selectedQuantity === this.quantity &&
        !this.cancelled
      ) {
        swal.fire({
          title: this.$t("Plan Selection Issue"),
          text: this.$t(
            "You have selected same plan as your current subscription. Please review and try again."
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        this.reset();
      } else if (
        this.selectedPlanType === "Pro" &&
        this.plan_type === "Enterprise"
      ) {
        swal.fire({
          title: this.$t("Plan Downgrade Issue"),
          text: this.$t(
            "Due to limitation on Pro plan, please contact us for assistance."
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        this.reset();
      } else if (this.selectedPlanType === "Pro" && this.code_valid) {
        swal.fire({
          title: this.$t("Plan Downgrade Issue"),
          text: "Cannot apply discount on PRO plan",
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        this.reset();
      } else {
        this.updatePrice();
      }
    },
    applyCoupon() {
      this.$store.dispatch("subscription/retrieveCoupon", {
        term: this.selectedFrequency,
        code: this.code
      });
    },
    reset() {
      if (this.quantity === 0) {
        this.selectedQuantity = 1;
      } else {
        this.selectedQuantity = this.quantity;
      }
      if (this.plan_type === USER_TYPE.FREE) {
        this.selectedQuantity = 1;
        this.selectedPlanType = "Pro";
        this.selectedFrequency = "y";
        this.selectedFreqLong = "Yearly";
      } else if (this.plan_type === undefined && this.pilotQuantity > 0) {
        this.selectedQuantity = this.pilotQuantity;
        this.selectedPlanType = "Pro";
        this.selectedFrequency = "y";
      } else {
        this.selectedPlanType = this.plan_type;
        this.selectedFrequency = this.plan_freq;
      }
      this.code_valid = false;
      this.percentOff = 0.0;
      this.discountAmount = 0;
      this.updatePrice();
    },
    submit() {
      if (this.card_last4 === undefined) {
        swal.fire({
          title: this.$t("Subscription Failure"),
          text: this.$t("Please add a credit card first!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        return;
      }
      swal
        .fire({
          title: this.$t("Confirmation"),
          text: this.$t(
            "We are about to place your subscription. Please confirm!"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            if (this.plan_type === undefined || this.cancelled) {
              var params = {
                plan_type: this.selectedPlanType,
                plan_freq: this.selectedFrequency,
                quantity: this.selectedQuantity
              };
              if (this.code_id) {
                params.promotion_code = this.code;
                params.promotion_code_id = this.code_id;
              }
              this.$store.dispatch("subscription/createSubscription", params);
            } else {
              this.$store.dispatch("subscription/updateSubscription", {
                plan_type: this.selectedPlanType,
                plan_freq: this.selectedFrequency,
                quantity: this.selectedQuantity
              });
            }
            this.percentOff = 0.0;
          }
        });
    },
    cancel() {
      if (this.pilotQuantity > 1) {
        swal.fire({
          title: this.$t("Failed to cancel subscription!"),
          text: this.$t(
            "There are more than one pilot in your account. Free plan can only have one pilot. Please remove other pilots before cancelling your subscription."
          ),
          type: "error",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
        return;
      }

      swal
        .fire({
          title: this.$t("Are you sure you want to cancel subscription?"),
          text: this.$t("We are so sorry to see you leave."),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("subscription/cancelSubscription");

            this.enterpriseIcon = "shopping_cart";
            this.proIcon = "shopping_cart";
          }
        });
    }
  }
};
</script>

<style lang="css">
.modal-dialog {
  overflow-y: initial !important;
}
.modal-body {
  overflow-y: auto;
}
.quantity {
  font-size: 20px;
  font-weight: 400;
  margin: 0px 20px 0px 20px;
  line-height: 51px;
  color: #666;
}

.md-button.md-steppers.md-horizontal.md-alternative .md-stepper-header {
  height: 104px;
  background-color: lightgrey;
}
.md-steppers-navigation {
  box-shadow: none;
}
</style>
